import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'instructionsTitle'
	| 'skillsTitle'
	| 'invocationDescriptionTitle'
	| 'knowledgeSourcesTitle'
	| 'deleteDescription'
	| 'allOrganisationalKnowledge'
	| 'noOrganisationalKnowledge';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		instructionsTitle: {
			id: 'ai-mate.studio-update-agent-draft.agent-diff.scenario-content.instructions-title',
			defaultMessage: 'Instructions',
			description: 'Title for the instructions section in scenario content',
		},
		skillsTitle: {
			id: 'ai-mate.studio-update-agent-draft.agent-diff.scenario-content.skills-title',
			defaultMessage: 'Skills',
			description: 'Title for the skills section in scenario content',
		},
		invocationDescriptionTitle: {
			id: 'ai-mate.studio-update-agent-draft.agent-diff.scenario-content.invocation-description-title',
			defaultMessage: 'Trigger',
			description: 'Title for the invocation description section in scenario content',
		},
		knowledgeSourcesTitle: {
			id: 'ai-mate.studio-update-agent-draft.agent-diff.scenario-content.knowledge-sources-title',
			defaultMessage: 'Knowledge',
			description: 'Title for the knowledge sources section in scenario content',
		},
		deleteDescription: {
			id: 'ai-mate.studio-update-agent-draft.agent-diff.scenario-content.delete-description',
			defaultMessage: 'Delete the {scenarioName} scenario.',
			description: 'Description text for a deleted scenario in scenario content',
		},
		allOrganisationalKnowledge: {
			id: 'ai-mate.studio-update-agent-draft.agent-diff.scenario-content.all-organisational-knowledge',
			defaultMessage: 'All organisational knowledge.',
			description:
				'Text indicating that all organisational knowledge is enabled in scenario content',
		},
		noOrganisationalKnowledge: {
			id: 'ai-mate.studio-update-agent-draft.agent-diff.scenario-content.no-organisational-knowledge',
			defaultMessage: 'No organisational knowledge.',
			description:
				'Text indicating that no organisational knowledge is enabled in scenario content',
		},
	});

export default message;
